import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.4376 15.8027L4.14468 7.50977L2.73047 8.92398L12.4376 18.6311L22.1447 8.92398L20.7305 7.50977L12.4376 15.8027Z",
		fill: "#395566"
	})
});
export default SvgLine;
